"use client";

import { AnimatePresence } from "framer-motion";
import DefaultView from "./default-view";
import { PerformanceSectionProps } from "../types/common";

export default function Performances({ data }: { data: PerformanceSectionProps }) {
  return (
    <>
      <AnimatePresence mode="wait">
        <DefaultView data={data} />
      </AnimatePresence>
    </>
  );
}
